import type { CSSProperties, ReactNode } from 'react';

export const gridDetailSectionStyle: CSSProperties = {
  border: '1px solid var(--ops-border, #e5e7eb)',
  borderRadius: 10,
  background: 'var(--ops-panel-bg, #f8fafc)',
  padding: '0.75rem 1rem'
};

export const gridDetailLabelStyle: CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: 'var(--ops-color-muted, #64748b)',
  marginBottom: 4
};

export function GridDetailSection({
  title,
  children
}: {
  title?: string;
  children: ReactNode;
}) {
  return (
    <div style={gridDetailSectionStyle}>
      {title ? <div style={gridDetailLabelStyle}>{title}</div> : null}
      {children}
    </div>
  );
}

export function GridDetailField({
  label,
  children,
  muted
}: {
  label: string;
  children: ReactNode;
  muted?: boolean;
}) {
  return (
    <div>
      <div style={{ ...gridDetailLabelStyle, marginBottom: 2 }}>{label}</div>
      <GridDetailValue muted={muted}>{children}</GridDetailValue>
    </div>
  );
}

export function GridDetailValue({ children, muted }: { children: ReactNode; muted?: boolean }) {
  return (
    <div
      className="ops-grid-detail-value"
      style={{
        margin: 0,
        fontSize: 14,
        lineHeight: 1.45,
        wordBreak: 'break-word',
        color: muted ? 'var(--ops-color-muted, #94a3b8)' : 'var(--ops-color-text, #111827)'
      }}
    >
      {children}
    </div>
  );
}

/** Responsive 2-column grid for dense read-only detail fields. */
export function GridDetailFieldsGrid({
  children,
  columns = 2
}: {
  children: ReactNode;
  columns?: 1 | 2;
}) {
  return (
    <div
      className={
        columns === 1
          ? 'ops-grid-detail-fields-grid ops-grid-detail-fields-grid--1col'
          : 'ops-grid-detail-fields-grid'
      }
    >
      {children}
    </div>
  );
}

/** Span both columns in a GridDetailFieldsGrid. */
export function GridDetailFieldsGridFull({ children }: { children: ReactNode }) {
  return <div className="ops-grid-detail-fields-grid__full">{children}</div>;
}
